import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_da2f4yq87r: FaireBrandEntity = {
  token: "b_da2f4yq87r",
  type: "brand",
  name: "Liffy",
  avatarUrl:
    "https://cdn.faire.com/fastly/4ce7909dc907eda7909652a322857485719fbd59286c2f1bd0ef2f8c27ab5139.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/ce277fec095ce2a85235c63996b1db3c244c2dbdc9a9504542eefe19303c4a0e.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/4ce7909dc907eda7909652a322857485719fbd59286c2f1bd0ef2f8c27ab5139.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ce277fec095ce2a85235c63996b1db3c244c2dbdc9a9504542eefe19303c4a0e.jpeg",
  location: "Ontario, CA, USA",
  minimumOrderDollars: 150,
  rating: 4.5,
  reviewCount: 227,
  isInsider: true,
  description:
    "At Liffy, we create thoughtfully designed home décor that blends modern style with everyday functionality. Our collections are crafted to help retailers offer pieces that are both visually appealing and easy to sell.\n\n✨ Trend-Driven Designs\nWe combine contemporary aesthetics with timeless elements, making our products suitable for a wide range of retail styles and seasonal displays.\n🏡 Made for Everyday Living\nFrom wall décor and vases to decorative accents, our pieces are designed to elevate living spaces while remaining practical and versatile.\n🛍 Retail-Ready Collections\nOur products are curated with strong sell-through potential, helping boutiques create cohesive displays that attract customers and encourage repeat purchases.\n📦 Consistent New Arrivals\nWe regularly introduce new designs to keep your assortment fresh and aligned with market trends.\n🤝 Wholesale Friendly\nFlexible ordering options designed to support boutiques of all sizes.\n\nWe’re committed to helping our retail partners grow with home décor that is stylish, functional, and easy to merchandise.\n\nFor inquiries or custom orders, feel free to contact us.",
  meta: {
    source: "api",
    importedAt: "2026-07-17T18:40:35.632Z",
    importedBy: "entity-db-cli",
  },
};
